<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper" style="height: 200px;">
      <!-- slides -->
      <swiper-slide
        v-for="(attachement, index) in attachementListFiltered || [{}]"
        :key="index"
      >
        <v-img
          contain
          :src="apiURL + 'archive/' + (attachement.archive || []).id"
          max-height="200"
        />

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="red"
              absolute
              right
              top
              @click="removeItem(attachement)"
              v-on="on"
              v-if="editable"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Descartar imagen</span>
        </v-tooltip>
      </swiper-slide>

      <swiper-slide
        v-if="attachementListFiltered && attachementListFiltered.length == 0"
      >
        <div
          class="d-flex flex-column align-center justify-center"
          style="min-height: 200px"
        >
          <div>
            <v-img :src="cp_logo" contain height="70"></v-img>
          </div>
          <p class="mt-2 body-2 font-weight-medium secondary--text">
            Galería sin imágenes
          </p>
        </div>
      </swiper-slide>

      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          @click="$refs.file.click()"
          fab
          small
          dark
          absolute
          bottom
          right
          v-on="on"
          v-if="editable && attachementListFiltered.length < maxLength"
        >
          <SvgIcon icon="cp-camera" fill="white" height="20px"></SvgIcon>
        </v-btn>
      </template>
      <span>Agregar imágenes (Máx 3 imágenes, máx 5MB)</span>
    </v-tooltip>
    <input
      hidden
      ref="file"
      type="file"
      accept="image/*"
      @change="addItem"
      multiple
    />

    <v-snackbar v-model="snackMaxLength" color="error"
      >Ha llegado al máximo de 3 fotos</v-snackbar
    >
    <v-snackbar v-model="snackError.show" color="error">{{
      snackError.msg
    }}</v-snackbar>
  </div>
</template>

<script>
import api from "../../api.js";
import SvgIcon from "@/components/SvgIcon";
export default {
  props: ["occurrenceId", "editable"],
  components: { SvgIcon },
  data: () => ({
    apiURL: api.baseURL,
    cp_logo: require("@/assets/logo.png"),
    attachementList: [],
    swiperOption: {
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    },
    maxLength: 3,
    snackMaxLength: false,
    snackError: {
      show: false,
      msg: ""
    }
  }),
  computed: {
    attachementListFiltered() {
      return (this.attachementList || []).filter(
        ({ deleted }) => !(deleted == true)
      );
    }
  },
  methods: {
    showAttachment: function() {
      this.dialogAttachment = true;
    },
    async addItem() {
      try {
        let files = this.$refs.file.files || [];
        this.$refs.file.files = null;

        for (let file of files) {
          if (this.attachementList.length >= this.maxLength) {
            this.snackMaxLength = true;
            break;
          }

          if (file.size > 5000000) {
            this.snackError = {
              show: true,
              msg: "Una imagen supera el tamaño máximo (5MB)"
            };
            continue;
          }
          let formData = new FormData();
          formData.append("fileupload", file);
          let { data: archiveCreated } = await this.$http.post(
            "archive",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          );

          this.attachementList.push({
            archive: archiveCreated
          });
        }

        this.$emit("update:attachementList", this.attachementList);
      } catch (err) {
        console.log(err);
      }
    },
    async removeItem(attachement) {
      let { id, archive } = attachement;
      if (id) {
        this.attachementList = this.attachementList.map(item =>
          item.id == id ? { ...item, deleted: true } : item
        );
      } else {
        let { id: idArchive } = archive;
        this.attachementList = this.attachementList.filter(
          ({ archive }) => archive.id != idArchive
        );
      }
      this.$emit("update:attachementList", this.attachementList);
    }
  },
  async mounted() {
    try {
      if (this.occurrenceId) {
        let { data: attachementList } = await this.$http.get("attachement", {
          params: {
            where: {
              occurrence: this.occurrenceId,
              deleted: false
            }
          }
        });
        this.attachementList = attachementList || [];
      }
    } catch (err) {
      console.log(err);
    }
  }
};
</script>

<style>
.swiper-slide {
  width: 100% !important;
  height: auto;
}
</style>
